var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.29,11.84H15.81V4.85l1.69-.62v2.51h1V3.87l.96-.35L10.01,.07,.66,3.47l3.66,1.37-.03,7.01Zm10.52-1H5.3l.03-5.38,4.77,1.78,4.72-1.72v5.32ZM10.01,1.14l6.53,2.38-6.53,2.38L3.55,3.48,10.01,1.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.55,15.62l.47-.03v-2.62H0v6.77H20.02v-2.8l-.48-.02c-.34-.02-.63-.26-.67-.55-.02-.16,.03-.33,.15-.47,.13-.16,.32-.26,.54-.28ZM1.01,13.97h1.16v4.77H1.01v-4.77Zm1.66,4.77v-4.77H19.02v.52H3.04v.5h15.5c-.11,.08-.21,.17-.3,.28-.2,.25-.32,.54-.35,.83H6.57v.5h11.33c.08,.38,.31,.72,.62,.95H3.04v.5h15.98v.68H2.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent4);
export default __webpack_public_path__ + "static/media/Agent-4.990663d1bfe59e5f21c76ecbbe6bcde5.svg";
export { ForwardRef as ReactComponent };